/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Dlh_MacosInputs */

const en_wc_dlh_macos = /** @type {(inputs: Wc_Dlh_MacosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One universal .dmg for Apple silicon and Intel Macs.`)
};

/**
* | output |
* | --- |
* | "One universal .dmg for Apple silicon and Intel Macs." |
*
* @param {Wc_Dlh_MacosInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_dlh_macos = /** @type {((inputs?: Wc_Dlh_MacosInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Dlh_MacosInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_dlh_macos(inputs)
});
export { wc_dlh_macos as "wc.dlh.macos" }